import React from "react";
import { Switch } from "antd";
import styled from "@emotion/styled";

const InputSwitch = ({ title, onChange, checked }) => {
  const handleChange = (checked) => {
    console.log(`switch to ${checked}`);
    onChange?.(checked);
  };
  return (
    <>
      <Switch
        style={checked ? { backgroundColor: "#a6dd50" } : {}}
        checked={checked}
        onChange={handleChange}
      />
      {title}
    </>
  );
};
export default InputSwitch;
